import { useCallback, useEffect, useState } from "react";

/**
 * Display density: type scale + cell padding + how wide table columns default
 * to. A full year of months only fits on a normal screen at the tighter steps,
 * so this is a first-class control rather than a browser-zoom job.
 */
export const STEPS = ["xs", "sm", "md", "lg"];

/** Multiplier applied to default column widths at each step. */
export const COL_SCALE = { xs: 0.72, sm: 0.85, md: 1, lg: 1.14 };

export const LABEL = { xs: "Smallest", sm: "Small", md: "Normal", lg: "Large" };

const KEY = "pd.density";

export function useDensity() {
  const [density, setDensity] = useState(() => {
    const saved = localStorage.getItem(KEY);
    return STEPS.includes(saved) ? saved : "md";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-density", density);
    localStorage.setItem(KEY, density);
  }, [density]);

  const step = useCallback((by) => {
    setDensity((d) => STEPS[Math.min(STEPS.length - 1, Math.max(0, STEPS.indexOf(d) + by))]);
  }, []);

  return {
    density,
    colScale: COL_SCALE[density],
    smaller: () => step(-1),
    bigger: () => step(1),
    canShrink: STEPS.indexOf(density) > 0,
    canGrow: STEPS.indexOf(density) < STEPS.length - 1,
  };
}

/** Scale a default column width for the current density. */
export const scaleCol = (px, colScale) => Math.round(px * colScale);
